import { Api } from 'utils';

class PaymentService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/payments',params),
		download: async (params?: any) => Api.createResponse('admin/payments/download',params)
	}

}

export default PaymentService;